import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import css from "./style.scss";
import classNames from "classnames";

const FormikText = ({
  name,
  label,
  placeholder = label,
  type = "text",
  required = false,
  numbers = false,
  decimal = false,
  maxLength = null,
  validationPattern = null, // Optional additional pattern
  disabled = false,
  errors = {},
  touched = {},
  className
}) => {
  const { setFieldValue } = useFormikContext();

  const handleInputChange = (e) => {
    let value = e.target.value;

    // Apply numbers/decimal restrictions
    if (numbers || decimal) {
      if (numbers && !decimal) {
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        value = value.replace(/\D/g, "");
      } else if (!numbers && decimal) {
        value = value.replace(/[^0-9.]/g, "");
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        if (value.startsWith(".")) value = "0" + value;
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          value = parts.join(".");
        }
      } else if (numbers && decimal) {
        value = value.replace(/[^0-9.]/g, "");
        if (value.startsWith("00")) value = value.replace(/^0+/, "0");
        if (value.startsWith(".")) value = "0" + value;
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (parts.length === 2) {
          parts[1] = parts[1].slice(0, 2);
          value = parts.join(".");
        }
      }
    }

    // Apply custom validationPattern if provided (remove matching pattern)
    if (validationPattern) {
      value = value.replace(validationPattern, "");
    }

    // Apply maxLength
    if (maxLength && value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    setFieldValue(name, value);
  };

  return (
    <div className={css.clsFormGroup}>
      <label
        className={classNames(
          css.clsFormLabel,
          errors[name] && touched[name] && css.text_danger
        )}
        htmlFor={name}
      >
        {label}
        {required && <span className={css.text_primary}>*</span>}
      </label>

      <Field name={name}>
        {({ field }) => (
          <input
            {...field}
            id={name}
            type={type}
            placeholder={placeholder}
            className={classNames(
              css.clsFormControl,
              className,
              errors[name] && touched[name] && css.clsBorderDanger,
              { [css.disabled]: disabled }
            )}
            disabled={disabled}
            maxLength={maxLength || undefined}
            onChange={handleInputChange}
            value={field.value || ""}
          />
        )}
      </Field>

      <ErrorMessage
        name={name}
        component="div"
        className={classNames(css.clsFormErrorText, css.text_danger)}
      />
    </div>
  );
};

export default FormikText;